(function () {
    'use strict';

    Directives.WorkflowProjectTypeSelectorDirective = function WorkflowProjectTypeSelectorDirective() {
        // @ngInject
        function WorkflowProjectTypeSelectorDirectiveControllerCtor($scope, $injector, _, CompaniesManager, $document, $translate, $element, PopupMessageService, $q) {
            this.constructor.$super.call(this, $scope, $injector);
            this.__objectType = 'WorkflowProjectTypeSelectorDirectiveController';

            this.$document = $document;
            this.CompaniesManager = CompaniesManager;
            this.$translate = $translate;
            this.PopupMessageService = PopupMessageService;
            this.$q = $q;

            this.selectedValueLabel = '';
            this.projectTypeSelectedCount = 0;
            this._ = _;
            this.company = this.CompaniesManager.getCurrCompany();
            this.isOpen = false;
            this.projectTypes = [];
            this.defaultForAllProjectTypesSelected = false;
            this.defaultForAllProjectTypesDisabled = false;
            this.rebuildViewModel();

            $element.addClass('workflow-project-selector');
            var listElement = $element.find('.workflow-project-selector__list');
            var selectedValueElement= $element.find('.workflow-project-selector__value');

            selectedValueElement.on('click', function toggleMenu(e) {
                var clickedInsideList = listElement.find(e.target).length > 0;
                if(clickedInsideList){
                    // no need to do anything the user can select more items before closing the dropdown.
                    return;
                }

                if (this.isOpen) {
                    this.close();
                } else {
                    this.open();
                }
            }.bind(this));

            // Close the menu if the user clicks outside.
            this.onOutsideBoundsClick = function onOutsideBoundsClick(e) {
                var isClickedInside = $element.find(e.target).length > 0;

                if (isClickedInside) {
                    return;
                }

                if (this.isOpen) {
                    this.close();
                }
            };

            this.open = function open() {
                this.isOpen = true;
                $element.addClass('workflow-project-selector--open');

                //rebuild the view model. it could have changed since last time.
                //some other project types have been chosen so we need to show them as disabled
                this.rebuildViewModel();
            };

            this.close = function close() {

                if (!this.isOpen) {
                    return;
                }

                this.isOpen = false;
                $element.removeClass('workflow-project-selector--open');

                if (angular.isFunction(this.saveModelCallback)) {
                    this.saveModelCallback({
                        workflowModel: this.workflowModel,
                        projectTypes: this.projectTypes,
                        defaultForAllProjectTypesSelected: this.defaultForAllProjectTypesSelected
                    }).then(function success() {
                        this.rebuildViewModel();
                    }.bind(this));
                }
            };
        }

        var WorkflowProjectTypeSelectorDirectiveController = Class(Controllers.BaseController, {
            constructor: WorkflowProjectTypeSelectorDirectiveControllerCtor,

            createProjectTypeViewModel: function createProjectTypeViewModel(projectType) {
                var newViewModel = {};
                angular.extend(newViewModel, projectType);
                newViewModel.isSelected = false;
                newViewModel.isDisabled = false;
                return newViewModel;
            },

            rebuildViewModel: function rebuildViewModel() {
                this.buildViewModel();
                this.updateSelected();
            },

            buildViewModel: function buildViewModel() {
                this.projectTypes.splice(0, this.projectTypes.length);
                this.defaultForAllProjectTypesDisabled = false;
                this.defaultForAllProjectTypesSelected = false;

                this.company.sortedProjectTypes().forEach(function iter(projectType) {
                    if (projectType.label.toLowerCase() !== "other") {
                        this.projectTypes.push(this.createProjectTypeViewModel(projectType));
                    }
                }.bind(this));
            },

            updateSelected: function updateSelected() {
                this.selectedValueLabel = '';
                this.projectTypeSelectedCount = 0;
                if (this.workflowModel.relevant_project_types && (this.workflowModel.relevant_project_types.length > 0)) {
                    this.workflowModel.relevant_project_types.forEach(function iter(selectedProjectType) {

                        if (this.selectedValueLabel.length > 0) {
                            this.selectedValueLabel += ', ';
                        }

                        //make that selected type selecetd on the view model
                        var projectTypeViewModel = this._.find(this.projectTypes, {_id: selectedProjectType});
                        if (projectTypeViewModel) {
                            projectTypeViewModel.isSelected = true;

                            this.projectTypeSelectedCount += 1;
                            this.selectedValueLabel += projectTypeViewModel.label;
                        } else {
                            if (selectedProjectType === 'workflow_project_type_default') {
                                this.defaultForAllProjectTypesSelected = true;

                                this.selectedValueLabel += this.$translate.instant('WORKFLOW.WORKFLOWS.PROJECT_TYPE_SELECTOR._DEFAULT_WORKFLOW_');
                            } else {
                                console.error('Could not find the project type. This should not have happened');
                            }
                        }
                    }.bind(this));
                }

                if (!this.selectedValueLabel) {
                    this.selectedValueLabel = this.$translate.instant('WORKFLOW.WORKFLOWS.PROJECT_TYPE_SELECTOR._NOT_ASSIGNED_');
                }

                //go over other types that have been selected on other workflows and make them disabled
                this._.forEach(this.projectTypeToWorkflowMap, function iter(workflow, projectType) {
                    // we want all the other workflows. not ours
                    if (workflow._id === this.workflowModel._id) {
                        return;
                    }

                    var projectTypeViewModel = this._.find(this.projectTypes, {_id: projectType});
                    if (projectTypeViewModel) {
                        projectTypeViewModel.isDisabled = true;
                    } else {
                        if (projectType === 'workflow_project_type_default') {
                            this.defaultForAllProjectTypesDisabled = true;
                        } else {
                            console.error('Could not find the project type. This should not have happened');
                        }
                    }
                }.bind(this));
            },

            onAllProjectToggled: function onAllProjectToggled() {
                if(this.defaultForAllProjectTypesDisabled){
                    return;
                }

                this.defaultForAllProjectTypesSelected = !this.defaultForAllProjectTypesSelected;

                if (this.defaultForAllProjectTypesSelected) {
                    this.projectTypes.forEach(function(projectType) {
                        projectType.isSelected = false;
                    });
                }
            },

            onProjectTypeToggled: function onProjectTypeSelected(projectTypeViewModel) {
                if (projectTypeViewModel.isDisabled){
                    return;
                }

                projectTypeViewModel.isSelected = !projectTypeViewModel.isSelected;

                // If all project types is selected, disable it
                if ((this.projectTypeToWorkflowMap.workflow_project_type_default &&
                    this.projectTypeToWorkflowMap.workflow_project_type_default._id === this.workflowModel._id) || projectTypeViewModel.isSelected) {
                    this.defaultForAllProjectTypesSelected = false;
                }
            },
        });


        return {
            restrict: 'E',
            templateUrl: 'angular/app/modules/core/features/workflows/workflow_project_type_selection_directive_template.html',
            controller: WorkflowProjectTypeSelectorDirectiveController,
            controllerAs: 'projectTypeSelectorVm',
            bindToController: true,
            scope: {
                workflowModel: '=',
                projectTypeToWorkflowMap: '=',
                saveModelCallback: '&'
            }
        };
    };

}());

